import React from 'react';
import { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import { sanitizeQueryParams } from '@/helpers/sanitize';
import HeadMetaTag from '@/components/metatags/HeadMetaTag';
import { fetchDataHandler, fetchNavigation } from '@/lib/fetcher';
import { ViagensList } from '@/features/viagens/ViagensList';
import CustomError from '@/features/errors';
import AppProvider from '@/context/AppProvider';

export const getServerSideProps: GetServerSideProps = async ({ req, query }) => {
  const { travelType } = query;
  const queryParams = new URLSearchParams();

  if (typeof travelType === 'string') {
    queryParams.set('travelType', sanitizeQueryParams(travelType, 100));
  }

  // Since 2025-07-13
  if (travelType === 'cruzeiros') {
    return {
      redirect: {
        destination: '/cruzeiros',
        permanent: true,
      },
    };
  }

  const path = `/viagens/${queryParams.get('travelType')}`;
  const [navigation, pageProps] = await Promise.all([
    fetchNavigation(),
    fetchDataHandler(path, 'VIAGENS TRAVELTYPE', req),
  ]);

  // @ts-expect-error FIXME LATER, this was introduced after a catch of an issue accessing the URL /viagens/crie-seu-roteiro'%7C%7C'
  if (!pageProps?.props?.data?.travelType) {
    return {
      notFound: true,
    };
  }

  const { props, notFound, redirect } = pageProps;
  if (notFound !== undefined) return { notFound: true };
  if (redirect !== undefined) return { redirect };
  if (props !== undefined) return { props: { ...props, navigation } };

  return {
    props: {
      data: null,
    },
  };
};

const Page = ({ data, error, ...props }: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  if (error) {
    return <CustomError error={error} />;
  }

  const { meta } = data;
  return (
    <AppProvider navigation={...props.navigation}>
      <HeadMetaTag meta={meta} />
      <ViagensList data={data} />
    </AppProvider>
  );
};

export default Page;
